/** Trigger a browser file download from a Blob. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

/** Sanitize a note title into a safe filename. */
export function sanitizeFilename(title: string): string {
  const cleaned = title
    .replace(/[/\\:*?"<>|#]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
  if (!cleaned) return 'Untitled'
  return cleaned.length > 100 ? cleaned.slice(0, 100).trim() : cleaned
}
